import { ChevronsUpDown } from 'lucide-react';
import { Button } from '../../../../components-ui/Button';

interface Props {
  areEventsExtended: boolean;
  setAreEventsExtended: (extended: boolean) => void;
  bottomOffset?: number;
}

export function TrackingEventsToggleButton({ areEventsExtended, setAreEventsExtended, bottomOffset = 8 }: Props) {
  return (
    <Button
      style={{
        position: 'absolute',
        bottom: bottomOffset,
        right: 8,
        filter: 'drop-shadow(0px 4px 8px rgba(138, 140, 158, 0.25))',
      }}
      className="z-10 h-7 w-7 rounded-full transition-opacity hover:bg-neutral-50 hover:text-neutral-600"
      onClick={() => setAreEventsExtended(!areEventsExtended)}
      variant="outline"
      size="icon"
      aria-label={areEventsExtended ? 'Collapse tracking events' : 'Expand tracking events'}
    >
      <ChevronsUpDown className="h-3.5 w-3.5" />
    </Button>
  );
}
